export default __webpack_public_path__ + "static/media/bonepile.30a4afaa.png";